var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTymeplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 93,
    viewBox: "0 0 75 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_667",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3342",
    "data-name": "Group 3342",
    transform: "translate(3.245 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.24, -6)",
    filter: "url(#Ellipse_667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_667-2",
    "data-name": "Ellipse 667",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3347",
    "data-name": "Group 3347",
    transform: "translate(14.616 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M88.525,113.664a22.027,22.027,0,0,1,22.027-22.027c5.028,0,10.374,2.329,14.081,5.165-4.016-3.953-10.237-7.036-16.318-7.036a22.254,22.254,0,0,0-10.482,41.883A22,22,0,0,1,88.525,113.664Z",
    transform: "translate(-86.064 -89.766)",
    fill: "#ee2738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M156.846,106.85a19.931,19.931,0,0,0-27.889-.4,23.332,23.332,0,0,1,27.889.4Z",
    transform: "translate(-118.276 -98.17)",
    fill: "#262525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M103.29,170.341a17,17,0,0,0,9.482,21.82,19.9,19.9,0,0,1-9.482-21.82Z",
    transform: "translate(-98.156 -150.277)",
    fill: "#262525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M185.995,133.135l-13.531,13.678-.968-1.031Z",
    transform: "translate(-150.223 -122.336)",
    fill: "#867970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M147.114,158l7.555,5.984-.957,1.041Z",
    transform: "translate(-131.912 -141.012)",
    fill: "#867970"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTymeplus);
export default __webpack_public_path__ + "static/media/tymeplus.4940a2af2345f1e9d7cc63bc42bb0bb4.svg";
export { ForwardRef as ReactComponent };